
import seoTags from "@/mixins/seoTags";
import policyFetchMixin from "@/mixins/policyFetchMixin";

export default {
	mixins: [seoTags, policyFetchMixin],
	mounted() {
		setTimeout(function () {window.scrollTo(0, -100);}, 1);
	},
}
